/*
 * Copyright 1999-2025 Jagex Ltd.
 */
export enum LoaderName {
  GetAccounts = 'game-accounts-page--get-accounts',
  SaveAccountsRank = 'game-accounts-page--save-accounts-rank',
  PageInit = 'gameAccountsPageInit'
}
